import { t } from "../../i18n";
import { APP_VERSION } from "../../lib/version";

/**
 * The build number, on every screen.
 *
 * This app installs to home screens and caches itself, so "which version are
 * you looking at?" is a real question with a non-obvious answer — an installed
 * copy can sit a build or two behind the site. Printing it means the answer is
 * always on screen rather than something someone has to be talked through
 * finding.
 *
 * Deliberately in the page flow rather than fixed to the viewport: the update
 * and install banners already own the bottom edge, and a version stamp should
 * never cover them.
 */
export function VersionFooter() {
  return (
    <footer className="versionfooter">
      <span title={t("Build version")}>{APP_VERSION}</span>
    </footer>
  );
}
